import React, { useState } from "react";
import { useParams, Routes, Route } from "react-router-dom";
import TripDetails from "./TripDetails";
import VariantDetails from "./VariantDetails";
import TripRegistrations from "./Registrations/TripRegistrations";
import RegistrationDetails from "./Registrations/RegistrationDetails";
import ParticipantDetails from "./Registrations/ParticipantDetails";
import VariantRegistrations from "./Registrations/VariantRegistrations";
import { TripProvider, useTripContext } from "./TripContext";
import LoadingOverlay from "../../LoadingOverlay";
import VariantLayout from "./Variants/VariantLayout";
import "../../css/TripWrapper.css";
import ParticipantsListWrapper from "./Participants/ParticipantsListWrapper";
import AccessPanel from "./Access/AccessPanel";
import Insurances from "./Insurances/Insurances";
import RegistrationEmailHistory from "./Registrations/RegistrationEmailHistory";
import Summary from "./Summary/Summary";
import DiscordChannelsSection from "./Discord/DiscordChannelsSection";
import DiscordChannelDetails from "./Discord/DiscordChannelDetails";
import RequestFullDataModal from "./RequestFullDataModal";

const InnerRoutes = () => {
  const { tripData, fetchTripData, fetchTripFullData, isFullData, error, loading } = useTripContext();
  const { variantguid } = useParams();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isFullModalOpen, setIsFullModalOpen] = useState(false); 
  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchTripData();
    setIsRefreshing(false);
  };

const handleFetchFull = async (reason) => {
  await fetchTripFullData(reason);
  setIsFullModalOpen(false);
};

  if (!tripData && error) {
    return (
      <div className="trip-details-error">
        <h2>Nie udało się załadować wycieczki</h2>
        <p>{error.message || "Wystąpił błąd podczas pobierania danych."}</p>
      </div>
    );
  }
  
  if (!tripData) {
    return <LoadingOverlay text="Ładowanie szczegółów wycieczki" />;
  }

  if (isRefreshing) {
    return <LoadingOverlay text="Odświeżanie danych" />;
  }

  return (
    <div className="trip-details-container">
      {!isFullData && (
    <div
      className="request-fulldata-btn top-right"
      onClick={() => setIsFullModalOpen(true)}
      title="Pobierz pełne dane (dostęp logowany)"
    >
      <i className="fa-solid fa-shield-halved" />
      Pobierz pełne dane
    </div>
  )}
<div className="trip-details-header">
  <div className="trip-title-center">
    <h1 className="trip-details-container-tripName">{tripData.name}</h1>
    <div className="refresh-button" onClick={handleRefresh} title="Odśwież dane">
      <i className="fa-solid fa-arrows-rotate" />
    </div>
  </div>
</div>



 <Routes>
  <Route path="/" element={<TripDetails />} />

  <Route path="variants/:variantguid" element={<VariantLayout />}>
    <Route index element={<VariantDetails />} />

    <Route path="registrations">
      <Route
        index
        element={
          <VariantRegistrations
            registrations={tripData?.registrations || []}
            variantGuid={variantguid}
          />
        }
      />
      <Route
        path=":resGuid"
        element={
          <RegistrationDetails
            registrations={tripData?.registrations || []}
          />
        }
      />
          <Route
      path=":resGuid/emailHistory"
      element={<RegistrationEmailHistory />}
    />
    </Route>

    <Route path="participants" element={<ParticipantsListWrapper/>} />

    <Route
      path="participants/:participantGuid"
      element={
        <ParticipantDetails
          registrations={tripData?.registrations || []}
        />
      }
    />
     <Route path="insurances" element={<Insurances />} />
  </Route>
  <Route path="insurances" element={<Insurances />} />
  <Route path="participants" element={<ParticipantsListWrapper/>} />

  <Route
    path="registrations"
    element={
      <TripRegistrations
        registrations={tripData?.registrations || []}
        variants={tripData?.variants || []}
      />
    }
  />
  <Route path="access" element={<AccessPanel />} />
  <Route path="summary" element={<Summary />} />
  <Route path="discord" element={<DiscordChannelsSection />} />
  <Route path="discord/:channelId" element={<DiscordChannelDetails />} />
</Routes>
{!isFullData && (
  <RequestFullDataModal
    isOpen={isFullModalOpen}
    onClose={() => setIsFullModalOpen(false)}
    onConfirm={handleFetchFull}
    isLoading={loading}
    tripName={tripData.name}
  />
)}


    </div>
  );
};

const TripWrapper = () => {
  const { guid } = useParams();

  return (
    <TripProvider guid={guid}>
        <InnerRoutes />
    </TripProvider>
  );
};

export default TripWrapper;
